import baseApi from "./baseApi"

async function getPestConfigurations() {
    let request = await baseApi.createHttpRequest();
    let result = await request.get("/pestconfigurations");
    return result.data;
}

async function addPestConfiguration(item, imageData) {
    let data = createDataForPestConfigurationRequest(item, imageData);

    let request = await baseApi.createHttpRequest();
    let result = await request.post("/pestconfigurations", data, {
        headers: {
            "Content-Type": "multipart/form-data; boundary=" + data._boundary
        }
    });

    return result.data;
}

async function updatePestConfiguration(item, imageData) {
    let data = createDataForPestConfigurationRequest(item, imageData);

    let request = await baseApi.createHttpRequest();
    let result = await request.put("/pestconfigurations", data, {
        headers: {
            "Content-Type": "multipart/form-data; boundary=" + data._boundary
        }
    });

    return result.data;
}

function createDataForPestConfigurationRequest(item, imageData) {
    let data = new FormData();

    data.set("item", JSON.stringify(item));
    
    let count = 1;
    imageData.forEach(image => {
        let imageDataClone = Object.assign({}, image);
        delete imageDataClone.Blob;

        data.set("imageDetails" + count.toString(), JSON.stringify(imageDataClone)); // everything except the actual image bytes should go here
        data.set("imageData" + count.toString(), image ? image.Blob : null); // actual image bytes are here, since this cannot be JSON stringified

        count++;
    });

    return data;
}

async function getPestClassifciations() {
    let request = await baseApi.createHttpRequest();
    let result = await request.get("/pestconfigurations/classifications");
    return result.data;
}

async function addPestClassification(item) {
    let request = await baseApi.createHttpRequest();
    let result = await request.post("/pestconfigurations/classifications", item);
    return result.data;
}

async function updatePestClassification(item) {
    let request = await baseApi.createHttpRequest();
    let result = await request.put("/pestconfigurations/classifications", item);
    return result.data;
}

async function getPestObservationsByLocationID(locationID) {
    let request = await baseApi.createHttpRequest();
    let result = await request.get(`/pestconfigurations/observations?locationID=${locationID}`);
    return result.data;
}

export default {
    getPestConfigurations,
    addPestConfiguration,
    updatePestConfiguration,
    getPestClassifciations,
    addPestClassification,
    updatePestClassification,
    getPestObservationsByLocationID
}